import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=5f100d0d&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f100d0d')) {
      api.createRecord('5f100d0d', component.options)
    } else {
      api.reload('5f100d0d', component.options)
    }
    module.hot.accept("./ImageSlider.vue?vue&type=template&id=5f100d0d&", function () {
      api.rerender('5f100d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ImageSlider.vue"
export default component.exports